"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShapeDiverGeometryBackendError = exports.ShapeDiverGeometryBackendResponseError = exports.ShapeDiverGeometryBackendRequestError = void 0;
const ShapeDiverError_1 = require("./ShapeDiverError");
class ShapeDiverGeometryBackendRequestError extends ShapeDiverError_1.ShapeDiverViewerError {
    // #region Constructors (1)
    constructor(message) {
        super(ShapeDiverError_1.ShapeDiverViewerErrorType.GEOMETRY_BACKEND_REQUEST_ERROR, "A request to the geometry backend failed.", message);
    }
}
exports.ShapeDiverGeometryBackendRequestError = ShapeDiverGeometryBackendRequestError;
class ShapeDiverGeometryBackendResponseError extends ShapeDiverError_1.ShapeDiverViewerError {
    // #region Constructors (1)
    constructor(message, status, geometryBackendErrorType, desc) {
        super(ShapeDiverError_1.ShapeDiverViewerErrorType.GEOMETRY_BACKEND_RESPONSE_ERROR, desc, message);
        this.status = status;
        this.geometryBackendErrorType = geometryBackendErrorType;
        this.desc = desc;
    }
}
exports.ShapeDiverGeometryBackendResponseError = ShapeDiverGeometryBackendResponseError;
class ShapeDiverGeometryBackendError extends ShapeDiverError_1.ShapeDiverViewerError {
    // #region Constructors (1)
    constructor(message) {
        super(ShapeDiverError_1.ShapeDiverViewerErrorType.GEOMETRY_BACKEND_ERROR, "A generic geometry backend error occurred.", message);
    }
}
exports.ShapeDiverGeometryBackendError = ShapeDiverGeometryBackendError;
//# sourceMappingURL=ShapeDiverBackendErrors.js.map